import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Globais from "../../css/Globais";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { createTheme } from "@mui/material/styles";
// import DialogTitle from "@mui/material/DialogTitle";
import {
  CalcularDiferencaDias,
  exibirMoeda,
  formatarData,
  formatarDataExibicao,
  formatarMoeda,
  validateToken,
} from "../Globais";
import ModalMostrarUsuario from "../ModalMostrarUsuario";
import axios from "axios";
import bolaPreta from "../../images/circulo_preto2.png";
import bolaAmarela from "../../images/bola_amarela.png";
import bolaVerde from "../../images/bola_verde.png";
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ThemeProvider, Typography } from "@mui/material";
import PrimeiraVezCadastroCotas from "../../screens/PrimeiraVezCadastroCotas";
import ModalMostrarPreco from "../ModalMostrarPreco";

const ContainerAluguel = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  max-height: 4rem;

  grid-template: 100% / 1fr 1fr 8% 8% 8% 8% 10% 10%;

  justify-content: flex-start;
  align-items: center;
  @media (max-width: 768px) {
    width: 170%;
  }
  @media (max-width: 536px) {
    width: 250%;
  }
`;

const ContainerTroca = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template: auto / 1fr 1fr 5% 12% 8% 8% 10% 10%;

  justify-content: flex-start;
  align-items: center;
`;
const ContainerImagem = styled.img`
  width: 2rem;
  height: 2rem;
  justify-items: flex-end;
`;

const Titulo = styled.h1`
  font-size: 1.5em;

  font-family: arial, arial, helvetica, san-serif;
  color: rgba(255, 255, 255, 1);
  padding: 10px;

  line-height: 0.6em;
  border: 1px solid white;
  // justify-self: center;
  text-align: center;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }

  // @media (max-width: 300px) {
  //   margin-left: 3rem;
  // }
  @media (min-width: 700px) {
    margin-left: 3rem;
  }
  @media (min-width: 800px) {
    margin-left: 4rem;
  }
  @media (min-width: 900px) {
    margin-left: 5rem;
  }
  @media (min-width: 1000px) {
    margin-left: 6rem;
  }

  @media (min-width: 1110px) {
    font-size: 1.8rem;
    margin-left: 7rem;
  }
  @media (min-width: 1200px) {
    margin-left: 8rem;
  }
  @media (min-width: 1400px) {
    font-size: 2.5em;
    margin-left: 9rem;
  }
`;
const ContainerPreco = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 15% 1fr 1fr / 1fr 1fr 1fr;
`;

const Container1 = styled.div`
  width: 100%;
  heght: 100%;

  grid-row-start: 1;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  background-color: #b2bec3;
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container2 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 1;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  background-color: #b2bec3;
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container3 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 2;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: flex-start;
  align-items: center;
`;
const Container4 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 2;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container5 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: flex-start;
  align-items: center;
`;
const Container6 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container7 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 4;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: flex-start;
  align-items: center;
`;
const Container8 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 4;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container9 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: flex-start;
  align-items: center;
`;
const Container10 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container11 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 6;
  grid-column-start: 1;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: flex-start;
  align-items: center;
`;
const Container12 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 6;
  grid-column-start: 2;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container13 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 1;
  grid-column-start: 3;
  background-color: #b2bec3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container14 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 2;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container15 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 4;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container16 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 4;
  grid-column-start: 4;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container17 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container18 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 6;
  grid-column-start: 4;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container19 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 1;
  grid-column-start: 3;
  background-color: #b2bec3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container20 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 2;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container21 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 3;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container22 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 4;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container23 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 5;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;
const Container24 = styled.div`
  width: 100%;
  heght: 100%;
  grid-row-start: 6;
  grid-column-start: 3;
  border: 1px solid ${Globais.CorAzulBackGround};
  display: grid;
  justify-content: center;
  align-items: center;
`;

const ContainerColunasAluguel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-left: 0.5rem;
  padding-left: 0.5rem;
  justify-content: center;

  align-items: center;
  border-right: 2px solid #dfe6e9;
  border-bottom: 1px solid #dfe6e9;
`;

const H3 = styled.h3`
  font-size: 0.6rem;
  margin-left: 1rem;

  color: ${Globais.CorAzulBackGround};
  @media (min-width: 500px) {
    font-size: 0.9rem;
  }
  @media (min-width: 700px) {
    font-size: 1.1rem;
  }
  @media (min-width: 900px) {
    font-size: 1.2rem;
  }
`;

const Box = styled.div`
  display: flex;
  justify-self: flex-end;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;
// const Box = styled.div`
//   display: flex;
//   justify-self: flex-end;
//   cursor: pointer;
//   border: none;
//   background-color: transparent;
// `;

const Abreviacao = styled.abbr`
  text-decoration: none;
  cursor: pointer;
`;
const defaultCelulas = {
  idUs: 0,
  idPEU: 0,
  nomeUs: "",
  nomeEP: "",
  numeroCota: "",
  checado: "",
  checkIn: "",
  checkOut: "",
  valor: "",
  divulgado: "",
  comissao: 0.0,
  valorCompraForaStays: 0.0,
  valorCompraStays: 0.0,
  valorCompraAirbnb: 0.0,
  diariaCotista: 0.0,
  diariaCompraForaStays: 0.0,
  diariaCompraStays: 0.0,
  diariaCompraAirbnb: 0.0,
  diariaCotistaTurbo: 0.0,
  diariaCompraForaStaysTurbo: 0.0,
  diariaCompraStaysTurbo: 0.0,
  diariaCompraAirbnbTurbo: 0.0,
};

const defaultUsuarioData = {
  nome: "",
  sobrenome: "",
  email: "",
  celular: "",
};
const defaultPeriodoUsuarioData = {
  divulgado: 0,
};
//

export interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onClose: (value: string) => void;
}
declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: React.CSSProperties["color"];
    };
  }

  interface ThemeOptions {
    status: {
      danger: React.CSSProperties["color"];
    };
  }

  interface Palette {
    neutral: Palette["primary"];
  }

  interface PaletteOptions {
    neutral: PaletteOptions["primary"];
  }

  interface PaletteColor {
    darker?: string;
  }

  interface SimplePaletteColorOptions {
    darker?: string;
  }
}
export default function TabelaLinha(props: any) {
  const tipo = props.tipo;
  const background = props.background;
  const colorTexto = props.color;
  // const [open, setOpen] = useState(false);
  const status = [
    { id: "0", nome: "Não Divulgado", imagem: bolaPreta },
    { id: "1", nome: "Divulgado", imagem: bolaAmarela },
    { id: "2", nome: "Concluído", imagem: bolaVerde },
  ];

  const [usuario, setUsuario] = useState<any | null>([{}]);

  const [usuarioData, setUsuarioData] = useState(defaultUsuarioData);
  const [periodoUsuarioData, setPeriodoUsuarioData] = useState(
    defaultPeriodoUsuarioData
  );

  const [isModalMostrarUsuarioVisible, setIsModalMostrarUsuarioVisible] =
    useState(false);
  const [isModalMostrarPrecoVisible, setIsModalMostrarPrecoVisible] =
    useState(false);

  const [conteudo, setConteudo] = useState<any | null>(defaultCelulas);

  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(status[0]);

  const { divulgado } = periodoUsuarioData;

  const sinalNaoDivulgado = useRef(false);
  const sinalDivulgado = useRef(false);
  const sinalConcluido = useRef(false);

  const percentualComissao = 0.15;
  const percentualComissaoEtaxas = 0.159;
  const percentualComissaoEtaxasEStays = 0.7014;
  const percentualCompraAirbnb = 0.3641;
  const dias = CalcularDiferencaDias(
    props.conteudo.checkOut,
    props.conteudo.checkIn
  );

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = (value: string) => {
  //   setOpen(false);
  //   setSelectedValue(value);
  // };

  useEffect(() => {
    const fetchToken = async () => {
      if (tipo === 2) {
        setConteudo((prevState: any) => ({
          ...prevState,
          idPEU: props.conteudo.idPEU,
          idUs: props.conteudo.idUs,
          nomeUs: `${props.conteudo.nomeUs} ${props.conteudo.sobrenome}`,
          nomeEP: props.conteudo.nomeEP,
          numeroCota: props.conteudo.numeroCota,
          checado: props.conteudo.checked === 1 ? "Sim" : "Não",
          checkIn: formatarData(props.conteudo.checkIn),
          checkOut: formatarData(props.conteudo.checkOut),
          valor: `R$ ${exibirMoeda(props.conteudo.valorMin)}`,
          divulgado: +props.conteudo.divulgado,
          alugar: +props.conteudo.alugar,
          trocar: +props.conteudo.trocar,
          comissao: `R$ ${exibirMoeda(
            (props.conteudo.valorMin * percentualComissao).toString()
          )}`,
          valorCompraForaStays: `R$ ${exibirMoeda(
            (
              props.conteudo.valorMin *
              (1 + percentualComissaoEtaxas)
            ).toString()
          )}`,
          valorCompraStays: `R$ ${exibirMoeda(
            (
              props.conteudo.valorMin *
              (1 + percentualComissaoEtaxasEStays)
            ).toString()
          )}`,
          valorCompraAirbnb: `R$ ${exibirMoeda(
            (props.conteudo.valorMin * (1 + percentualCompraAirbnb)).toString()
          )}`,
          diariaCotista: `R$ ${exibirMoeda(
            (props.conteudo.valorMin / dias).toString()
          )}`,
          diariaCompraForaStays: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualComissaoEtaxas)) /
              dias
            ).toString()
          )}`,
          diariaCompraStays: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualComissaoEtaxasEStays)) /
              dias
            ).toString()
          )}`,
          diariaCompraAirbnb: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualCompraAirbnb)) /
              dias
            ).toString()
          )}`,
          diariaCotistaTurbo: `R$ ${exibirMoeda(
            (props.conteudo.valorMin / 3).toString()
          )}`,
          diariaCompraForaStaysTurbo: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualComissaoEtaxas)) /
              3
            ).toString()
          )}`,
          diariaCompraStaysTurbo: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualComissaoEtaxasEStays)) /
              3
            ).toString()
          )}`,
          diariaCompraAirbnbTurbo: `R$ ${exibirMoeda(
            (
              (props.conteudo.valorMin * (1 + percentualCompraAirbnb)) /
              3
            ).toString()
          )}`,
        }));

        if (+props.conteudo.divulgado === 0) {
          sinalNaoDivulgado.current = true;
        } else {
          if (+props.conteudo.divulgado === 1) {
            sinalDivulgado.current = true;
          } else {
            if (+props.conteudo.divulgado === 2) {
              sinalConcluido.current = true;
            }
          }
        }
      } else if (tipo === 1) {
        setConteudo((prevState: any) => ({
          ...prevState,
          nomeUs: props.conteudo[0],
          nomeEP: props.conteudo[1],
          numeroCota: props.conteudo[2],
          checado: props.conteudo[3],
          checkIn: props.conteudo[4],
          checkOut: props.conteudo[5],
          valor: props.conteudo[6],
          divulgado: props.conteudo[7],
        }));
      } else if (tipo === 3) {
        setConteudo((prevState: any) => ({
          ...prevState,
          nomeUs: props.conteudo[0],
          nomeEP: props.conteudo[1],
          numeroCota: props.conteudo[2],
          cidade: props.conteudo[3],
          checkIn: props.conteudo[4],
          checkOut: props.conteudo[5],
          alugar: props.conteudo[6],
          divulgado: props.conteudo[7],
        }));
      } else if (tipo === 4) {
        setConteudo((prevState: any) => ({
          ...prevState,
          idPEU: props.conteudo.idPEU,
          idUs: props.conteudo.idUs,
          nomeUs: `${props.conteudo.nomeUs} ${props.conteudo.sobrenome}`,
          nomeEP: props.conteudo.nomeEP,
          numeroCota: props.conteudo.numeroCota,
          cidade: `${props.conteudo.nomeCID} - ${props.conteudo.estado}`,
          checkIn: formatarData(props.conteudo.checkIn),
          checkOut: formatarData(props.conteudo.checkOut),
          estado: props.conteudo.estado,
          divulgado: +props.conteudo.divulgado,
          alugar: +props.conteudo.alugar === 0 ? "Não" : "Sim",
          trocar: +props.conteudo.trocar,
        }));

        if (+props.conteudo.divulgado === 0) {
          sinalNaoDivulgado.current = true;
        } else {
          if (+props.conteudo.divulgado === 1) {
            sinalDivulgado.current = true;
          } else {
            if (+props.conteudo.divulgado === 2) {
              sinalConcluido.current = true;
            }
          }
        }
      }
    };
    fetchToken();
  }, []);

  const theme = createTheme({
    status: {
      danger: "#e53e3e",
    },
    palette: {
      primary: {
        main: Globais.CorTexto,
        darker: Globais.CorTexto,
      },
      neutral: {
        main: "#64748B",
        contrastText: "#fff",
      },
    },
  });

  const clickOnPreco = () => {
    setIsModalMostrarPrecoVisible(true);
  };

  const clickOnUsuario = async (event: any) => {
    setIsModalMostrarUsuarioVisible(true);
    const usuarioId = event.target.id;

    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;
      ////
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          usuarioData.nome = response.data.nome;
          usuarioData.sobrenome = response.data.sobrenome;
          usuarioData.email = response.data.email;
          usuarioData.celular = response.data.celular;
          setUsuario(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      document.location.href = "/";
    }
  };

  const atualizarPeriodo = async (props: any) => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${conteudo.idPEU}`;

      try {
        const response = await axios.put(URL, props, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleClose = async (event: any) => {
    if (event === "0") {
      if (sinalNaoDivulgado.current === true) {
        setOpen(false);
      } else {
        sinalNaoDivulgado.current = true;
        sinalDivulgado.current = false;
        sinalConcluido.current = false;
        periodoUsuarioData.divulgado = 0;

        atualizarPeriodo(periodoUsuarioData);
      }
    } else {
      if (event === "1") {
        if (sinalDivulgado.current === true) {
          setOpen(false);
        } else {
          sinalNaoDivulgado.current = false;
          sinalDivulgado.current = true;
          sinalConcluido.current = false;

          periodoUsuarioData.divulgado = 1;

          atualizarPeriodo(periodoUsuarioData);
        }
      } else {
        if (event === "2") {
          if (sinalConcluido.current === true) {
            setOpen(false);
          } else {
            sinalNaoDivulgado.current = false;
            sinalDivulgado.current = false;
            sinalConcluido.current = true;

            periodoUsuarioData.divulgado = 2;

            atualizarPeriodo(periodoUsuarioData);
          }
        }
      }
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  // Tipo:
  // 1 - Alugueis Titulo
  function SimpleDialog(props: SimpleDialogProps) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
      onClose(selectedValue);
    };

    const handleListItemClick = (value: string) => {
      onClose(value);
    };
    return (
      <>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Selecione uma opção</DialogTitle>
          <List sx={{ pt: 0 }}>
            {status.map((item) => (
              <ListItem disableGutters>
                <ListItemButton
                  onClick={() => handleListItemClick(item.id)}
                  key={item.id}
                >
                  <ListItemAvatar>
                    <ContainerImagem src={item.imagem} alt="" />
                  </ListItemAvatar>
                  <ListItemText primary={item.nome} />
                </ListItemButton>
              </ListItem>
            ))}
            {/* <ListItem disableGutters>
              <ListItemButton
                autoFocus
                onClick={() => handleListItemClick("addAccount")}
              >
                <ListItemAvatar>
                  {/* <Avatar>
                  <AddIcon />
                </Avatar> 
                </ListItemAvatar>
                <ListItemText primary="Add account" />
              </ListItemButton>
            </ListItem> */}
          </List>
        </Dialog>
      </>
    );
  }

  return (
    <>
      {tipo === 1 || tipo === 2 ? (
        <ContainerAluguel
          style={{ backgroundColor: background, color: colorTexto }}
        >
          <ContainerColunasAluguel>
            <Box onClick={clickOnUsuario} id={conteudo.idUs}>
              {conteudo.nomeUs}
            </Box>
          </ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.nomeEP}</ContainerColunasAluguel>
          <ContainerColunasAluguel>
            {conteudo.numeroCota}
          </ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.checado}</ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.checkIn}</ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.checkOut}</ContainerColunasAluguel>
          <ContainerColunasAluguel>
            <Box onClick={clickOnPreco} id={conteudo.valor}>
              {conteudo.valor}
            </Box>
          </ContainerColunasAluguel>
          <ContainerColunasAluguel>
            <ThemeProvider theme={theme}>
              <Button color="primary" onClick={handleClickOpen}>
                {tipo === 1 ? conteudo.divulgado : null}
                {tipo === 2 && sinalNaoDivulgado.current === true ? (
                  <Abreviacao title="Não Divulgado">
                    <ContainerImagem src={bolaPreta} alt="" />
                  </Abreviacao>
                ) : null}
                {tipo === 2 && sinalDivulgado.current === true ? (
                  <Abreviacao title="Divulgado">
                    <ContainerImagem src={bolaAmarela} alt="" />
                  </Abreviacao>
                ) : null}
                {tipo === 2 && sinalConcluido.current === true ? (
                  <Abreviacao title="Concluído">
                    <ContainerImagem src={bolaVerde} alt="" />
                  </Abreviacao>
                ) : null}
              </Button>
            </ThemeProvider>
          </ContainerColunasAluguel>
        </ContainerAluguel>
      ) : null}
      {tipo === 3 || tipo === 4 ? (
        <ContainerTroca
          style={{ backgroundColor: background, color: colorTexto }}
        >
          <ContainerColunasAluguel>
            <Box onClick={clickOnUsuario} id={conteudo.idUs}>
              {conteudo.nomeUs}
            </Box>
          </ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.nomeEP}</ContainerColunasAluguel>
          <ContainerColunasAluguel>
            {conteudo.numeroCota}
          </ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.cidade}</ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.checkIn}</ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.checkOut}</ContainerColunasAluguel>
          <ContainerColunasAluguel>{conteudo.alugar}</ContainerColunasAluguel>
          <ContainerColunasAluguel>
            <ThemeProvider theme={theme}>
              <Button color="primary" onClick={handleClickOpen}>
                {tipo === 3 ? conteudo.divulgado : null}
                {tipo === 4 && sinalNaoDivulgado.current === true ? (
                  <Abreviacao title="Não Divulgado">
                    <ContainerImagem src={bolaPreta} alt="" />
                  </Abreviacao>
                ) : null}
                {tipo === 4 && sinalDivulgado.current === true ? (
                  <Abreviacao title="Divulgado">
                    <ContainerImagem src={bolaAmarela} alt="" />
                  </Abreviacao>
                ) : null}
                {tipo === 4 && sinalConcluido.current === true ? (
                  <Abreviacao title="Concluído">
                    <ContainerImagem src={bolaVerde} alt="" />
                  </Abreviacao>
                ) : null}
              </Button>
            </ThemeProvider>
          </ContainerColunasAluguel>
        </ContainerTroca>
      ) : null}
      {isModalMostrarUsuarioVisible ? (
        <ModalMostrarUsuario
          onClose={() => setIsModalMostrarUsuarioVisible(false)}
        >
          <H3>{usuario.nome}</H3>
          <H3>{usuario.sobrenome}</H3>
          <H3>{usuario.email}</H3>
          <H3>{usuario.celular}</H3>
        </ModalMostrarUsuario>
      ) : null}
      {isModalMostrarPrecoVisible ? (
        <ModalMostrarPreco onClose={() => setIsModalMostrarPrecoVisible(false)}>
          <ContainerPreco>
            <Container1>
              <H3>Descrição</H3>
            </Container1>
            <Container2>
              <H3>Valor</H3>
            </Container2>
            <Container3>
              <H3>Valor Cotista</H3>
            </Container3>
            <Container4>
              <H3>{conteudo.valor}</H3>
            </Container4>
            {/* <Container5>
              <H3>Comissão</H3>
            </Container5>
            <Container6>
              <H3>{conteudo.comissao}</H3>
            </Container6> */}
            {/* <Container7>
              <H3>Valor compra fora da Stays</H3>
            </Container7>
            <Container8>
              <H3>{conteudo.valorCompraForaStays}</H3>
            </Container8> */}
            <Container9>
              <H3>Valor a ser colocado na stays</H3>
            </Container9>
            {/* <Container10>
              <H3>{conteudo.valorCompraStays}</H3>
            </Container10> */}
            {/* <Container11>
              <H3>Valor cobrado Airbnb</H3>
            </Container11>
            <Container12>
              <H3>{conteudo.valorCompraAirbnb}</H3>
            </Container12> */}
            {/* <Container19>
              <H3>{`Diárias (3)`}</H3>
            </Container19> */}

            <Container20>
              {dias === 7 ? <H3>{conteudo.diariaCotistaTurbo}</H3> : null}
            </Container20>
            {/* <Container21>
              <H3></H3>
            </Container21> */}
            {/* <Container22>
              {dias === 7 ? (
                <H3>{conteudo.diariaCompraForaStaysTurbo}</H3>
              ) : null}
            </Container22> */}
            {/* <Container23>
              {dias === 7 ? <H3>{conteudo.diariaCompraStaysTurbo}</H3> : null}
            </Container23> */}
            {/* <Container24>
              {dias ===7?(
                 <H3>{conteudo.diariaCompraAirbnbTurbo}</H3>
              ):null}
             
            </Container24> */}

            <Container13>
              <H3>{`Diárias (${dias})`}</H3>
            </Container13>
            <Container14>
              <H3>{conteudo.diariaCotista}</H3>
            </Container14>
            <Container15>
              <H3></H3>
            </Container15>
            {/* <Container16>
              <H3>{conteudo.diariaCompraForaStays}</H3>
            </Container16> */}
            <Container17>
              <H3>{conteudo.diariaCompraStays}</H3>
            </Container17>
            {/* <Container18>
              <H3>{conteudo.diariaCompraAirbnb}</H3>
            </Container18> */}
          </ContainerPreco>

          {/* <H3>{usuario.sobrenome}</H3>
          <H3>{usuario.email}</H3>
          <H3>{usuario.celular}</H3> */}
        </ModalMostrarPreco>
      ) : null}

      <SimpleDialog
        selectedValue={selectedValue.nome}
        open={open}
        onClose={handleClose}
      />
    </>
  );
}
